

import VesselMonitoringSingleBay from "./VesselMonitoringSingleBay.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    VesselMonitoringSingleBay
  },
  props: {
    vesselHatch: { type: Object as () => any, default: () => ({ vesselBays: [] }) },
    vesselBay: { type: Object},
    minDeckTiersNo:{default: 0},
    minHoldTiersNo:{default: 0},
    BayNo:{type:String}
  },
  mounted() {
  },
  computed: {
    ...mapGetters(["getVesselMonitoringData"]),
    
    vesselMonitoringData() {
      return this.getVesselMonitoringData;
    }
  },
}
